import "./whyUsDeliveryPath.css";

const deliveryPractices = [
  {
    number: "01",
    title: "Align Before You Scale",
    description:
      "Start with a risk-free demo to align on quality expectations, scope, and commercial terms.",
  },
  {
    number: "02",
    title: "Set Clear Quality Targets",
    description:
      "Use multi-level quality checks and daily tracking of throughput and quality against project targets.",
  },
  {
    number: "03",
    title: "Prepare Before Kick-off",
    description:
      "Brief and train the team before project work begins, with expectations defined in advance.",
  },
  {
    number: "04",
    title: "Bring in the Right Specialists",
    description:
      "Engage domain experts—such as engineers, microbiologists, or former teachers—for specialised verticals.",
  },
  {
    number: "05",
    title: "Work Within Your Ecosystem",
    description:
      "Deliver on a platform-agnostic basis, including directly within client-proprietary tools and platforms where required.",
  },
  {
    number: "06",
    title: "Ramp Up with a Plan",
    description:
      "Use structured ramp-up plans with defined resourcing timelines to support a clear start.",
  },
];

export default function WhyUsDeliveryPath() {
  return (
    <section className="why-us-delivery-path">
      <div className="why-us-delivery-path__container">
        <header className="why-us-delivery-path__header">
          <div className="why-us-delivery-path__eyebrow">
            <span
              className="why-us-delivery-path__eyebrow-dot"
              aria-hidden="true"
            />
            HOW WE DELIVER
          </div>

          <div className="why-us-delivery-path__heading-row">
            <h2 className="why-us-delivery-path__title">
              A Delivery Model Built
              <br className="why-us-delivery-path__desktop-break" />
              {" "}
              <span>Around Your Requirements</span>
            </h2>

            <p className="why-us-delivery-path__intro">
              Every engagement starts with alignment on scope, quality
              expectations, tools, and timelines. Our teams follow a
              structured approach so projects can ramp up clearly and
              progress can be tracked throughout delivery.
            </p>
          </div>
        </header>

        <div className="why-us-delivery-path__grid">
          {deliveryPractices.map((practice) => (
            <article
              className="why-us-delivery-path__item"
              key={practice.number}
            >
              <div className="why-us-delivery-path__item-top">
                <span className="why-us-delivery-path__number">
                  {practice.number}
                </span>

                <span
                  className="why-us-delivery-path__marker"
                  aria-hidden="true"
                />
              </div>

              <h3 className="why-us-delivery-path__item-title">
                {practice.title}
              </h3>

              <p className="why-us-delivery-path__description">
                {practice.description}
              </p>
            </article>
          ))}
        </div>

        <div className="why-us-delivery-path__footer">
          <span className="why-us-delivery-path__footer-line" />

          <p>
            A structured approach. Clear expectations. Delivery built around
            your requirements.
          </p>

          <span className="why-us-delivery-path__footer-line" />
        </div>
      </div>
    </section>
  );
}